<aside class="full-width white-bg h-100-p">
    <div class="tree-header">
        <h3 class="m-0 title">Overview</h3>
    </div>
    <div class="tree-content" *ngIf="treeList.length > 0">
        <app-document-tree-node [list]="treeList" [parentList]="[]" [folderChange]="folderChange" [dmsConfig]="dmsConfig"></app-document-tree-node>
    </div>
</aside>